(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsImageWithTab = {
    init: function($section) {

      var duration = 4;
      var interval = 50;
      var slider = document.querySelector('.tabs-image-wrap');
      var progressBars = document.querySelectorAll('.progress');

      var flkty = new Flickity(slider, {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false
      });

      // Main function
      var percentTime,
        step,
        tick,
        isPaused = false;

      function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPaused = false;
        tick = window.setInterval(increase, interval);
      };

      function increase() {
        if (!isPaused) {
          step = (duration * 1000) / interval;
          percentTime += 100 / step;
          var currentSlideIndex = flkty.selectedIndex;
          var currentProgressBar = progressBars[currentSlideIndex];
          currentProgressBar.style.width = percentTime + "%";
          if (percentTime >= 100) {
            flkty.next();
            startProgressbar();
          }
        }
      }

      function resetProgressbar() {
        progressBars.forEach(function(progress) {
          progress.style.width = 0 + '%';
        });
        clearTimeout(tick);
      }

      flkty.on('change', function(index) {
        resetProgressbar();
        startProgressbar();
        updateTextClasses(index);
      });

      function updateTextClasses(index) {
        var textContents = document.querySelectorAll('.tabs-content');
        textContents.forEach(function(textContent, i) {
          if (i === index) {
            textContent.classList.add('is-active');
          } else {
            textContent.classList.remove('is-active');
          }
        });
      }

      startProgressbar();

      var observer = new IntersectionObserver(function(entries) {
        // Check if the section is intersecting with the viewport
        if (entries[0].isIntersecting) {
          // Start the Flickity slider
          startProgressbar();
        } else {
          // Stop the Flickity slider
          resetProgressbar();
        }
      }, { threshold: 0 });

      // Observe the section
      var section = document.querySelector('.image-tab-section');
      observer.observe(section);

      // Click event handler for headings
      $('.tabs-content').click(function(e) {
        e.preventDefault();
        $('.tabs-content').removeClass('is-active');
        $(this).addClass('is-active');
        var index = $(this).index();
        flkty.select(index);
      });

    },
    unload: function($section) {

    }
  }
})();
